module.exports = __webpack_public_path__ + "img/location.becf0829.svg";